export default "__VITE_ASSET__C99IfKsd__"